import { isDevMode, Directive, ElementRef, TemplateRef, Renderer2, ViewContainerRef, Input, NgModule } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
class ComponentErrorHandlerDirective {
    constructor(element, templateRef, renderer, viewContainer) {
        this.element = element;
        this.templateRef = templateRef;
        this.renderer = renderer;
        this.viewContainer = viewContainer;
        this.subscriptions = new Subscription();
        this.hasAddedVisualErrorMessage = false;
    }
    ngOnInit() {
        this.updateView(this.componentErrorHandler.hasErrors.getValue());
        this.subscriptions.add(this.componentErrorHandler.hasErrors.subscribe((hasErrors) => this.updateView(hasErrors)));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateView(hasErrors) {
        if (isDevMode() && hasErrors) {
            this.viewContainer.clear();
            this.addVisualErrorMessage();
        }
        else {
            if (!this.viewContainer.length) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        }
    }
    addVisualErrorMessage() {
        if (this.hasAddedVisualErrorMessage) {
            return;
        }
        const div = this.renderer.createElement('div');
        const text = this.renderer.createText(this.componentErrorHandler.getErrorMessage());
        this.renderer.appendChild(div, text);
        this.renderer.appendChild(this.element.nativeElement.parentElement, div);
        this.hasAddedVisualErrorMessage = true;
    }
}
ComponentErrorHandlerDirective.ɵfac = function ComponentErrorHandlerDirective_Factory(t) { return new (t || ComponentErrorHandlerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
ComponentErrorHandlerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComponentErrorHandlerDirective, selectors: [["", "componentErrorHandler", ""]], inputs: { componentErrorHandler: "componentErrorHandler" } });
ComponentErrorHandlerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: TemplateRef },
    { type: Renderer2 },
    { type: ViewContainerRef }
];
ComponentErrorHandlerDirective.propDecorators = {
    componentErrorHandler: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComponentErrorHandlerDirective, [{
        type: Directive,
        args: [{
                selector: '[componentErrorHandler]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }]; }, { componentErrorHandler: [{
            type: Input
        }] }); })();

class ComponentErrorHandler {
    constructor(componentName, packageName = '') {
        this.componentName = componentName;
        this.packageName = packageName;
        this.errors = [];
        this.warnings = [];
        this.hasErrors = new BehaviorSubject(false);
    }
    addError(message) {
        const error = new Error(this.buildMessage(message));
        if (this.errorAlreadyExists(error)) {
            console.log(`supressed duplicate error '${error.message}'`);
        }
        else {
            this.errors.push(error);
            if (!this.hasErrors.getValue()) {
                this.hasErrors.next(true);
            }
            throw error;
        }
    }
    errorAlreadyExists(error) {
        return this.errors.some((e) => e.message === error.message);
    }
    buildMessage(message) {
        let prependedMessage = this.packageName ? this.packageName + ' : ' : '';
        prependedMessage += this.componentName + ' : ';
        prependedMessage += message;
        return prependedMessage;
    }
    addWarning(message) {
        const warning = this.buildMessage(message);
        if (this.warningAlreadyExists(warning)) {
            console.log(`supressed duplicate warning '${warning}'`);
        }
        else {
            this.warnings.push(warning);
            console.warn(warning);
        }
    }
    warningAlreadyExists(warning) {
        return this.warnings.some((w) => w === warning);
    }
    checkNull(value, propName) {
        if (value === null) {
            this.addError(`${propName} cannot be set to null`);
        }
    }
    getErrorMessage() {
        return `${this.componentName} has errors. See the console for details.`;
    }
}

class ComponentErrorHandlerModule {
}
ComponentErrorHandlerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ComponentErrorHandlerModule });
ComponentErrorHandlerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ComponentErrorHandlerModule_Factory(t) { return new (t || ComponentErrorHandlerModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComponentErrorHandlerModule, { declarations: function () { return [ComponentErrorHandlerDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ComponentErrorHandlerDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComponentErrorHandlerModule, [{
        type: NgModule,
        args: [{
                declarations: [ComponentErrorHandlerDirective],
                exports: [ComponentErrorHandlerDirective],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ComponentErrorHandler, ComponentErrorHandlerDirective, ComponentErrorHandlerModule };

//# sourceMappingURL=mt-ng2-component-error-handler.js.map